import { SIDEStatus } from '@react/lib/api/enum';
import * as React from 'react';
import { ActiveStyledChip, InactiveStyledChip } from './SIDEStatusChip.styled';
var SIDEStatusChip = function (props) {
    return props.status === SIDEStatus.Active ? (React.createElement(ActiveStyledChip, { label: props.label })) : (React.createElement(InactiveStyledChip, { label: props.label }));
};
var ɵ0 = SIDEStatusChip;
export default SIDEStatusChip;
export { ɵ0 };
